// 信箱登入 - 輸入信箱

const EmailLoginInput = ({ t, email, setEmail, hintEmail, onSubmitEmail, setHintEmail }) => {
    return (
        <>
            <p className="text-h3 text-jblack">{t('INPUT_EMAIL')}</p>
            <p className="text-bd1m text-black9 opacity-[.8] mt-[12px] mb-[16px]">
                {t('USE_EMAIL')}
            </p>
            {/* 信箱輸入 */}
            <input
                className="border-1 border-[rgba(173,173,173,.24)] rounded-[100px] text-btn1 text-black9 placeholder:text-black2 p-[16px] w-full text-center"
                placeholder={t('EMAIL_PLACEHOLDER')}
                type="email"
                value={email}
                onChange={(e) => {
                    setHintEmail(false);
                    setEmail(e.target.value);
                }}
                maxLength={100}
            />

            {/* 錯誤格式提示 */}
            {hintEmail && <p className="text-btn2 text-[#d3392f] mt-[16px]">{t('EMAIL_HINT')}</p>}

            <button
                onClick={onSubmitEmail}
                disabled={email.trim() === ''}
                className={`text-white w-full block mt-[22px] rounded-[40px] text-btn1 text-center trans p-[16px]
            ${email.trim() !== '' ? 'bg-vPurple' : 'bg-black2'}`}
            >
                {t('CONTINUE')}
            </button>
        </>
    );
};

export default EmailLoginInput;
